import { Button, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useForm, useWatch } from 'react-hook-form'
import BackButton from '../BackButton'
import { validateEmptyFields } from '../../helpers/util'
import InputTextFieldGrid from '../common/InputTextFieldGrid'
import InputImageFieldGrid from '../common/InputImageFieldGrid'
import CustomButton from 'components/CustomButton'
import { useNavigate } from 'react-router-dom'

const SegmentForm = ({ defaultValues, submit, validate }) => {
  const navigate = useNavigate();
  const { control, handleSubmit } = useForm({ defaultValues });
  const [disabled, setDisabled] = useState(false);
  const watch = useWatch({ control });

  useEffect(() => {
    setDisabled(validateEmptyFields(watch, { validate, skip_fields: ["code"] }));
    // eslint-disable-next-line
  }, [watch]);

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <div>
          <BackButton click={() => navigate(-1)} />
        </div>
        <div className="container-title">
          <div className="title">Recargas Celular</div>
          <div className="subtitle">Segmentos</div>
        </div>
        <div style={{ width: "170px" }}></div>
      </Grid>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Grid
          container
          direction="row"
          m={"40px"}
          maxWidth={"70%"}
          justifyContent="center"
          spacing={3}
        >
          <InputTextFieldGrid
            xs={6}
            name={"name"}
            control={control}
            required={"Debes agregar el nombre de segmento"}
            label={"Nombre"}
          />
          <InputTextFieldGrid
            xs={6}
            name={"carrierId"}
            control={control}
            required={"Debes agregar el identificador de la operadora"}
            label={"Identificador"}
            inputType={"number"}
            step={false}
          />
          <InputTextFieldGrid
            xs={12}
            name={"code"}
            control={control}
            label={"Código"}
          />
          <InputTextFieldGrid
            xs={12}
            name={"description"}
            control={control}
            required={"Debes agregar una descripción de segmento"}
            label={"Descripción"}
          />
          <InputImageFieldGrid
            xs={12}
            name={"file"}
            control={control}
            required={"Debes agregar el logo de segmento"}
            label={"Logo"}
            style={{ display: "flex" }}
          />
          <Grid container item justifyContent={'center'} mt={4}>
            <CustomButton
              click={handleSubmit(submit)}
              name={"Guardar"}
              disabled={disabled}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default SegmentForm